import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { Field, Form, FormSpy } from 'react-final-form';
import Typography from './modules/components/Typography';
import AppFooter from './modules/views/AppFooter';
import AppAppBar from './modules/views/AppAppBar';
import AppForm from './modules/views/AppForm';
import { email, required } from './modules/form/validation';
import RFTextField from './modules/form/RFTextField';
import FormButton from './modules/form/FormButton';
import FormFeedback from './modules/form/FormFeedback';
import withRoot from './modules/withRoot';
import axios from "axios";
import { API_BASE_URL, API_SIGN_UP_PATH, UI_SIGN_IN_PATH, TIME_DELAY_MSEC } from './consts';
import ProductValues from './modules/views/ProductValues';
import { useNavigate } from "react-router-dom"
import Snackbar from './modules/components/Snackbar';


function SignUp() {
  const [open, setOpen] = React.useState(true);
  const handleClose = () => {
    setOpen(false);
  };
  const [sent, setSent] = React.useState(false);

  const [errorMessage, setErrorMessage] = React.useState('')

  const validate = (values: { [index: string]: string }) => {
    const errors = required(['username', 'email', 'password1', 'password2'], values);

    if (!errors.email) {
      const emailError = email(values.email);
      if (emailError) {
        errors.email = emailError;
      }
    }

    return errors;
  };

  const navigation = useNavigate()

  const handleSignUp = async (username: string, email: string, password1: string, password2: string) => {
    try {
      // Create the POST request
      setErrorMessage('');
      const response = await axios.post(
        `${API_BASE_URL}${API_SIGN_UP_PATH}`,
        {
          username: username,
          email: email,
          password1: password1,
          password2: password2,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        }
      );
      console.log('200', response.data);
      console.log('200', response.status);
      // navigation("/")

      if (response.status === 201) {
        // TODO: I have to change the following I guess
        // Successful sign-up, handle further actions if needed
        // For example, you can set tokens and navigate to a new page
        // localStorage.clear();
        // localStorage.setItem('access_token', data.access);
        // localStorage.setItem('refresh_token', data.refresh);
        // axios.defaults.headers.common['Authorization'] = `Bearer ${data['access']}`;
        // window.location.href = '/';
        console.log('201', response.data);
        setTimeout(() => {
          setErrorMessage("... Success!");
        }, 1000);

        setTimeout(() => {
          navigation(UI_SIGN_IN_PATH);
        }, 2000);
      }
    } catch (error: any) {
      if (error.response.status === 400) {
        setSent(false);
        setErrorMessage(JSON.stringify(error.response.data));
        console.log(error.response.data);
      } else if (error.response.status === 500) {
        setSent(false);
        setErrorMessage("Please try later as we are experiencing an server error. Appologies for the inconvenience.");
        console.log('500', error.response.data);
      } else {
        setSent(false);
        setErrorMessage("Please try later as we are experiencing an error. Appologies for the inconvenience.");
        console.error('Error during sign up:', error);
      }
    }
  };

  const handleSubmit = (values: { [index: string]: string }) => {
    setSent(true);
    handleSignUp(values.username, values.email, values.password1, values.password2);
  };

  return (
    <React.Fragment>
      <AppAppBar />
      <AppForm>
        <React.Fragment>
          <Typography variant="h3" gutterBottom marked="center" align="center">
            Sign Up
          </Typography>
          <Typography variant="body2" align="center">
            <Link href="/sign-in/" underline="always">
              Already have an account?
            </Link>
          </Typography>
        </React.Fragment>
        <Form
          onSubmit={handleSubmit}
          subscription={{ submitting: true }}
          validate={validate}
        >
          {({ handleSubmit: handleSubmit2, submitting }) => (
            <Box component="form" onSubmit={handleSubmit2} noValidate sx={{ mt: 6 }}>
              {/* <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Field
                    autoFocus
                    component={RFTextField}
                    disabled={submitting || sent}
                    autoComplete="given-name"
                    fullWidth
                    label="First name"
                    name="firstName"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={RFTextField}
                    disabled={submitting || sent}
                    autoComplete="family-name"
                    fullWidth
                    label="Last name"
                    name="lastName"
                    required
                  />
                </Grid>
              </Grid> */}
              <Field
                autoComplete="username"
                component={RFTextField}
                disabled={submitting || sent}
                fullWidth
                label="Username"
                margin="normal"
                name="username"
                required
              />
              <Field
                autoComplete="email"
                component={RFTextField}
                disabled={submitting || sent}
                fullWidth
                label="Email"
                margin="normal"
                name="email"
                required
              />
              <Field
                fullWidth
                component={RFTextField}
                disabled={submitting || sent}
                required
                name="password1"
                autoComplete="new-password"
                label="Password"
                type="password"
                margin="normal"
              />
              <Field
                fullWidth
                component={RFTextField}
                disabled={submitting || sent}
                required
                name="password2"
                autoComplete="new-password"
                label="Password confimation"
                type="password"
                margin="normal"
              />
              <FormSpy subscription={{ submitError: true }}>
                {({ submitError }) =>
                  submitError ? (
                    <FormFeedback error sx={{ mt: 2 }}>
                      {submitError}
                    </FormFeedback>
                  ) : null
                }
              </FormSpy>
              <FormButton
                sx={{ mt: 3, mb: 2 }}
                disabled={submitting || sent}
                color="secondary"
                fullWidth
              >
                {submitting || sent ? 'In progress…' : 'Sign Up'}
              </FormButton>
              {errorMessage && (
                <Typography variant="body2" color="error" align="center">
                  {errorMessage}
                </Typography>
              )}
              <Snackbar
                open={open}
                closeFunc={handleClose}
                message="当サービスの利用に際しては、法人プランへのサブスクリプションが必要です。SignUpの前にPricing Plansのページをご参照ください。"
              />
            </Box>
          )}
        </Form>
      </AppForm>
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(SignUp);
